"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefix = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var client_1 = require("react-dom/client");
var Sentry = __importStar(require("@sentry/react"));
var react_1 = require("react");
var EntryCommon_1 = require("@components/providers/EntryCommon");
exports.prefix = "/admin/liff/free_text";
var Index = (0, react_1.lazy)(function () { return Promise.resolve().then(function () { return __importStar(require("@pages/freeText/index")); }); });
var Pages = function () {
    Sentry.init({
        //ToDo:development 本番リリース前に変更する
        dsn: "https://feaa3a8e127a4237b8c4c0aeca8ae098@o507787.ingest.sentry.io/6598865",
        maxBreadcrumbs: 50,
        debug: true,
    });
    return ((0, jsx_runtime_1.jsx)(EntryCommon_1.EntryCommon, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Routes, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: exports.prefix, element: (0, jsx_runtime_1.jsx)(Index, {}) }) }) }));
};
/**
 * Entry Point
 */
var root = document.getElementById("root");
if (root !== null) {
    (0, client_1.createRoot)(root).render((0, jsx_runtime_1.jsx)(Pages, {}));
}
